import React, { useEffect } from "react";
import { uploadFiles } from "../../state/Storage";
import { areYouSure } from "../helpers";
import { closePopUp } from "../utils/Overlay";

export default function ContentFiles({
  filesToUpload,
  post,
  onSuccess,
}: {
  filesToUpload: FileList;
  post: Post;
  onSuccess: Function;
}) {
  const { files, cancel, success } = uploadFiles(filesToUpload, post);

  function cancelUploading() {
    cancel();
    closePopUp();
  }

  useEffect(() => {
    if (filesToUpload.length === 0) {
      closePopUp();
      return;
    }
    if (success) {
      closePopUp();
      onSuccess();
    }
  }, [success]);

  return (
    <>
      <h3 className="tac">Uploading files...</h3>
      <p className="tac mb1">
        <small>Please do not navigate away from this page.</small>
      </p>
      <hr />
      <ul className="list-reset">
        {files
          .filter((file) => !file.done)
          .map((file, i) => {
            if (file.uploaded === -1) {
              // error state
              return (
                <li key={i}>
                  <small className="error">✖ {file.name}</small>
                </li>
              );
            }
            return (
              <li key={i}>
                <span className={file.done ? "" : "preloader"}>
                  {file.done ? (
                    "✔ "
                  ) : (
                    <span
                      style={{ width: `${(file.uploaded / 100) * 30}px` }}
                    ></span>
                  )}
                </span>{" "}
                <small>{file.name}</small>
              </li>
            );
          })}
      </ul>
      <hr />
      <button
        className="reset as-link block"
        onClick={areYouSure(
          cancelUploading,
          "You are about to cancel the upload. Are you sure?"
        )}
      >
        ✖ Cancel
      </button>
    </>
  );
}
